import styled from "styled-components";
import Color from "../assets/Colors";

const Text = styled.p`
   margin: 0;
   color: ${props => props.color || Color.primary};
   font-size: ${props => props.size || "1em"};
   font-weight: ${props => props.weight || "200"};
   line-height: ${props => props.lineHeight || "1.1em"};
   
`;

export default Text;
